import {
  initialState,
  Actions,
  State,
  UPDATE_ENROLLMENT,
  UPDATE_ENROLLMENT_SUCCESS,
  UPDATE_ENROLLMENT_ERROR,
} from "../../types/enrollment/update.dto";

const reducers = (state = initialState, action: Actions): State => {
  switch (action.type) {
    case UPDATE_ENROLLMENT:
      return {
        ...state,
        states: {
          loading: true,
          success: false,
          error: false,
        },
      };
    case UPDATE_ENROLLMENT_SUCCESS:
      return {
        ...state,
        states: {
          loading: false,
          success: true,
          error: false,
        },
      };
    case UPDATE_ENROLLMENT_ERROR:
      return {
        ...state,
        states: {
          loading: false,
          success: false,
          error: action.payload,
        },
      };
    default:
      return { ...state };
  }
};

export default reducers;
